import { Controller } from '@hotwired/stimulus'

type FormControl = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement

export default class InputRevealController extends Controller<HTMLElement> {
  declare readonly revealableTargets: HTMLElement[]
  declare readonly triggerTargets: HTMLInputElement[]

  static targets = ['revealable', 'trigger']

  connect() {
    this.#updateVisibility()
    this.dispatch('connect')
  }

  toggle() {
    this.#updateVisibility()
  }

  #updateVisibility() {
    for (const revealable of this.revealableTargets) {
      const { inputRevealFor } = revealable.dataset
      const isHidden = !this.triggerTargets.find(t => t.value === inputRevealFor)?.checked

      revealable.classList.toggle('hidden', isHidden)

      if (revealable instanceof HTMLFieldSetElement) {
        revealable.disabled = isHidden
      } else {
        revealable.querySelectorAll<FormControl>('input, select, textarea').forEach(input => {
          input.disabled = isHidden
        })
      }
    }
  }
}
